/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-badge">
	<template>
		<custom-style>
			<style>
        .badge {
          display: inline-block;
          padding: 0.55em 0.4em;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 1.25rem;
          color: #fff;
        }

        .badge-pill {
          padding-right: 0.8em;
          padding-left: 0.8em;
          margin: 0.4em 0.4em 0 0;
          border-radius: 10rem;
          font-size: 14px;
        }

        .badge-small {
          font-size: 12px;
        }

        .badge-light {
          color: #212529;
          background-color: var(--cs-light-color);
        }

        .badge-primary {
          background-color: var(--cs-access-brand-color);
        }

        .badge-danger {
          background-color: var(--nintendo-brand-color);
        }

        .badge-info {
          background-color: var(--playstation-brand-color);
        }

        .badge-warning {
          background-color: var(--paper-amber-600);
        }

        .badge-success {
          background-color: var(--cs-color-xbox-green);
        }

        .badge-center {
          text-align: center;
        }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
